import { observer } from 'mobx-react-lite'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Search, XLg } from 'react-bootstrap-icons'
import { SearchContext } from '../../../../contexts/SearchContext'

const DEBOUNCE_MS = 400

export default observer(function SearchField() {
  const { search } = useContext(SearchContext)
  const [value, setValue] = useState(search.username || '')
  const timeout = useRef(null)

  useEffect(() => {
    if ((search.username || '') !== value) setValue(search.username || '')
  }, [search.username])

  useEffect(() => () => clearTimeout(timeout.current), [])

  const apply = term => {
    clearTimeout(timeout.current)
    const trimmed = term.trim()
    if (trimmed === (search.username || '')) return
    search.username = trimmed
    search.tag_names = trimmed
    search.order = trimmed ? 'username' : 'reach'
  }

  const onChange = ({ target }) => {
    setValue(target.value)
    clearTimeout(timeout.current)
    timeout.current = setTimeout(() => apply(target.value), DEBOUNCE_MS)
  }

  const clear = () => {
    setValue('')
    apply('')
  }

  return (
    <div className="flex h-11 min-w-0 flex-1 items-center gap-2 rounded-lg border-1 border-rb-lite-grey dark:border-rb-dark-mode-lighter bg-white dark:bg-rb-dark-mode px-3 focus-within:border-2 focus-within:border-rb-green">
      <Search className="shrink-0 text-rb-mat-grey dark:text-gray-400" />
      <input
        type="text"
        value={value}
        onChange={onChange}
        onKeyDown={event => event.key === 'Enter' && apply(value)}
        placeholder="Search by username or tag"
        className="h-full w-full border-0 bg-transparent p-0 text-sm text-rb-black dark:text-white placeholder-rb-mat-grey dark:placeholder-gray-500 focus:ring-0"
      />
      {value && (
        <button type="button" onClick={clear} title="Clear search" className="shrink-0 rounded-md p-1 text-rb-mat-grey hover:bg-rb-grey dark:text-gray-400 dark:hover:bg-rb-dark-mode-lighter">
          <XLg className="text-xs" />
        </button>
      )}
    </div>
  )
})
